import * as React from 'react';
import AdMarking from '../general/ad-marking';
import Srcset from '../general/srcset';
import Logo from '../general/logo';
import { ResultItem, Locals } from '../../types';
import FinnResults from '../finn';

export type Props = { resultItem: ResultItem; locals: Locals };

export default function RealestateResultsSwitch(props: Props) {
    const { locals } = props;
    const { prometheusData } = locals;
    if (prometheusData && prometheusData.channel === 'finn') {
        const phone = prometheusData.device === 'phone';
        return <FinnResults {...props} phone={phone} />;
    }
    return <RealestateResults {...props} />;
}

export function RealestateResults(props: Props) {
    const { resultItem } = props;
    const {
        landscape,
        heading,
        svgLogo,
        orgName,
        srcSet,
        mainImage,
    } = resultItem;

    return (
        <div
            className="realestate-banner"
            data-controller="srcsetController imgSrcController"
        >
            <div className="media-wrapper">
                <AdMarking />
                <div
                    className={`media landscape_${landscape}`}
                    id="data-distribution-background"
                >
                    <Srcset srcSet={srcSet} mainImage={mainImage} />
                    <Logo svgLogo={svgLogo} orgName={orgName} />
                </div>
            </div>
            <div className="caption-wrapper">
                <div className="caption-heading line-clamp-heading line-clamp-2">
                    {heading}
                </div>
            </div>
        </div>
    );
}
